import pubsub from './pubsub';
import { AuthKind, PUBSUB } from '@backbase/foundation-ang/web-sdk';
import { mockProviders } from './mockprovider';
import { AuthConfig } from 'angular-oauth2-oidc';

export const identityUrl = "https://identity.banesco.com.do";

export const environment: any = {
  name: 'prod',
  production: false,
  animation: false,
  mockProviders: [...mockProviders, { provide: PUBSUB, useValue: pubsub }],
  apiRoot: '/api',
  locales: ['en-US', 'es-DO'],
  firebaseConfig: {
    apiKey: "AIzaSyCUUeFewdLsNi_gBJDrxjqCrBs1rk99w8g",
    authDomain: "banesco-rd-prod.firebaseapp.com",
    projectId: "banesco-rd-prod",
    storageBucket: "banesco-rd-prod.appspot.com",
    messagingSenderId: "770952253803",
    appId: "1:770952253803:web:01acb0dd2574938dc13c2e",
    measurementId: "G-YVDT7CP49P"
  },
  webSdkConfig: {
    auth: {
      kind: 'custom',
      authUrl: `${identityUrl}/auth`,
      landingPageUrl: '/',
      clientId: 'banesco-retail',
      realm: 'banesco-retail',
      scope: 'openid-connect',
      maxInactivityDuration: 300,
      countdownDuration: 60,
    },
    apiRoot: '/api',
    staticResourcesRoot: '',
    locales: ['en','es'],
  },
  onboardingUrl: 'https://prospect.banesco.com.do',
};


export const authConfig: (baseUrl: string) => AuthConfig = (_baseUrl: string = '') => ({
  issuer: `${identityUrl}/auth/realms/banesco-retail`, //https://cx.bancadigitalqa.banesco.com.do
  redirectUri:  document.location.origin + '/select-context',
  loginUrl: `${identityUrl}/auth/realms/banesco-retail/protocol/openid-connect/auth`,
  end_session_endpoint: `${identityUrl}/auth/realms/banesco-retail/protocol/openid-connect/logout`,
  tokenEndpoint: `${identityUrl}/auth/realms/banesco-retail/protocol/openid-connect/token`,
  userinfo_endpoint: `${identityUrl}/auth/realms/banesco-retail/protocol/openid-connect/userinfo`,
  introspection_endpoint: `${identityUrl}/auth/realms/banesco-retail/protocol/openid-connect/token/introspect`,
  registration_endpoint: `${identityUrl}/auth/realms/banesco-retail/clients-registrations/openid-connect`,
  revocation_endpoint: `${identityUrl}/auth/realms/banesco-retail/protocol/openid-connect/revoke`,
  clientId: 'banesco-retail',
  responseType: 'code',
  scope: 'openid-connect',
  waitForTokenInMsec: 10000,
  showDebugInformation: true,
  requireHttps: false,
  logoutUrl: document.location.origin + '/logout',
  useSilentRefresh: true,
  silentRefreshTimeout: 5000,
  silentRefreshRedirectUri: document.location.origin + '/assets/silent-refresh.htm',
});
